import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function CTA() {
  const { t } = useI18n();
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <h2>{t('cta.title')}</h2>
        <p>{t('cta.sub')}</p>
        <a href="https://flautreach.com/auth"><button className="btn-cta">{t('cta.btn')}</button></a>
      </div>
    </section>
  );
}